import { getStore } from '../store/store';

export default function getIsCopilotThemeAccentColorUpdate(): boolean {
    return getStore().isAccentColorUpdate;
}
